import LabChangeUserPassword from "components/mnl/lab/labAuth/labChangeUserPassword";

const LabChangeUserPasswordPage = () => {
  return <LabChangeUserPassword />;
};

export default LabChangeUserPasswordPage;
